import { ROTULO_DO_STATUS_DO_PLANO, type StatusDoPlano } from "@bookdental/schemas";
import { cn } from "@/lib/cn";

const COR: Record<StatusDoPlano, string> = {
  RASCUNHO: "bg-zinc-100 text-zinc-700",
  APRESENTADO: "bg-brand-50 text-brand-700",
  APROVADO: "bg-emerald-50 text-emerald-700",
  RECUSADO: "bg-red-50 text-red-700",
  CONCLUIDO: "bg-emerald-600 text-white",
  CANCELADO: "bg-zinc-100 text-zinc-500 line-through",
};

export function SeloDoStatus({ status }: { status: StatusDoPlano }) {
  return (
    <span className={cn("rounded-full px-2 py-0.5 text-[10.5px] font-semibold uppercase tracking-wide", COR[status])}>
      {ROTULO_DO_STATUS_DO_PLANO[status]}
    </span>
  );
}
